module.exports = __webpack_public_path__ + "img/login-account-bg2.5fd0a238.png";